<ng-container
    *ngIf="{ isOpen: isOpen$ | async, context: context$ | async } as data"
>
    <p-dialog
        [(visible)]="data.isOpen"
        (onHide)="close()"
        [modal]="true"
        [style]="{ width: '50vw', height: 'auto' }"
        styleClass="error-dialog"
        [breakpoints]="{ '768px': '90vw' }"
        [showHeader]="false"
        [draggable]="false"
        [resizable]="false"
    >
        <div class="modal-inner-container">
            <!-- <img src="/assets/icons/ic_dialog_warning.svg" alt="Warning icon" /> -->
            <h2>{{ data.context?.title || '' }}</h2>
            <p>{{ data.context?.description || '' }}</p>

            <ng-container
                *ngIf="
                    data.context &&
                    data.context.buttons &&
                    data.context.buttons.length > 0
                "
            >
                <div class="buttons-container">
                    <ng-container
                        *ngFor="let buttonContent of data.context.buttons"
                    >
                        <button
                            pButton
                            [class.btn-single]="
                                data.context.buttons.length === 1
                            "
                            [class.btn-primary]="buttonContent.isPrimary"
                            [class.btn-primary-inverse]="
                                !buttonContent.isPrimary
                            "
                            (click)="close(); buttonContent.onClick()"
                        >
                            {{ buttonContent.text }}
                        </button>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </p-dialog>
</ng-container>
